var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlFilledFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 36,
    viewBox: "0 0 33 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1051 21.3169C29.4986 20.6155 28.4394 20.5265 27.7238 21.1223L22.7692 25.2474C21.8132 26.0434 20.6085 26.4793 19.3645 26.4793H13.5064C12.6253 26.4793 11.911 25.765 11.911 24.8839C11.911 24.0028 12.6253 23.2885 13.5064 23.2885H15.3481H19.1299C20.011 23.2885 20.7253 22.5742 20.7253 21.6931C20.7253 20.812 20.0111 20.0977 19.1299 20.0977H9.79368C8.00323 20.0977 6.34926 21.0551 5.45762 22.6078L4.74282 23.8526C4.24979 24.7112 3.63743 25.4955 2.92411 26.1822L0 28.9967L4.21238 35.9958L7.03537 33.3561C7.75102 32.6869 8.69413 32.3147 9.67387 32.3147H17.1212C18.873 32.3147 20.5676 31.6912 21.9017 30.5559L29.8725 23.7728C30.6072 23.1609 30.7306 22.0401 30.1051 21.3169Z",
    fill: "#2D5E59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0128 15.2748C29.482 9.30592 25.0366 4.44617 19.2679 3.28812C19.3081 3.10291 19.3297 2.91082 19.3297 2.7138C19.3297 1.2174 18.1123 0 16.616 0C15.1197 0 13.9023 1.2174 13.9023 2.71373C13.9023 2.91082 13.9239 3.10284 13.9641 3.28804C8.19546 4.44617 3.75007 9.30599 3.21927 15.2748H0.632812V17.6772H32.5993V15.2748H30.0128Z",
    fill: "#2D5E59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlFilledFour);
export default __webpack_public_path__ + "static/media/al-filled-four.34456b6cb085e92c089db775fc662cdd.svg";
export { ForwardRef as ReactComponent };